import { useContext, useEffect, useState } from 'react';

import FirebaseContext from '../../../../context/FirebaseContext';
import useComponentMounted from '../../../../hooks/useComponentMounted';
import { listNetlifySites } from '../../../utils/webflowDeployer';
import texts from '../texts.json';

/**
 * The Netlify sites the deployer can target, fetched once per page load and shared by every
 * file's site picker.
 *
 * @returns {Object} { sites, isLoading, error }
 */
const useNetlifySites = () => {
  const { firebase: { remote } } = useContext(FirebaseContext);
  const isComponentMountedRef = useComponentMounted();

  const [sites, setSites] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const result = await listNetlifySites(remote);
        if (isComponentMountedRef.current) {
          setSites(result);
        }
      } catch (loadError) {
        if (isComponentMountedRef.current) {
          setError(loadError.message || texts.sitesLoadFailed);
        }
      }
      if (isComponentMountedRef.current) {
        setIsLoading(false);
      }
    };
    load();
  }, [
    remote,
    isComponentMountedRef,
  ]);

  return {
    sites,
    isLoading,
    error,
  };
};

export default useNetlifySites;
